import { Button, Modal, Paper, Slide, Typography } from '@material-ui/core'
import WalletIcon from '@material-ui/icons/AccountBalanceWalletRounded'

import { addCommaToPrice } from '../../helpers/numbers'
import { getDirection, getTranslate } from '../../localization'
import { Currency } from '../../types/currency'
import useStyles from './index.styles'

export interface ChangePriceModalProps {
  title: string
  subTitle: string
  isOpen: boolean
  onClose: () => void
  onClick: () => void
  price: number
  currency: Currency
}

export const ChangePriceModal: React.FC<ChangePriceModalProps> = ({
  title,
  subTitle,
  isOpen,
  onClose,
  onClick,
  price,
  currency
}) => {
  const classes = useStyles()

  return (
    <Modal open={isOpen} onClose={onClose} dir={getDirection()}>
      <Slide direction="down" in={isOpen}>
        <Paper className={classes.deletePaper}>
          <div className={classes.header}>
            <WalletIcon className={classes.icon} />
            <Typography variant="h4" className={classes.title}>
              {getTranslate(title)}
            </Typography>
          </div>
          <div>
            <Typography variant="h6" className={classes.subTitle}>
              {getTranslate(subTitle)}
            </Typography>
          </div>
          <div className={classes.buttonsContainer}>
            <Button
              variant="contained"
              className={classes.deleteButton}
              onClick={onClick}
              color="primary">
              <Typography variant="h5" className={classes.changeText}>
                {`${getTranslate('Pay')} | ${addCommaToPrice(
                  price
                )} ${getTranslate(currency || '')}`}
              </Typography>
            </Button>
          </div>
        </Paper>
      </Slide>
    </Modal>
  )
}
